import { render } from "./Arrow.vue?vue&type=template&id=ef71f1c4&scoped=true&ts=true"
import script from "./Arrow.vue?vue&type=script&lang=ts"
export * from "./Arrow.vue?vue&type=script&lang=ts"

import "./Arrow.vue?vue&type=style&index=0&id=ef71f1c4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef71f1c4"]])

export default __exports__